import { AccountRegistrations } from '@interfaces';
import { createAction, props } from '@ngrx/store';

export const UpdateAccountRegistrations = createAction(
  '[Account Registrations] Update Account Registrations',
  props<{ payload: AccountRegistrations[] }>(),
);

export const LoadAccountRegistrations = createAction(
  '[Account Registrations] Load Account Registrations',
);
